import type {MattressUVControlPoint} from "#mattress/nodes/curve/mattress-curve"

const MAN_UV_RING_SCALE = 0.8

export const manUVLevel = {
    bottomFaceCentre: 1,
    bottomFace: MAN_UV_RING_SCALE, // 0.8
    bottomCorner: MAN_UV_RING_SCALE ** 2, // 0.64
    sidesBottom: MAN_UV_RING_SCALE ** 3, // 0.512
    sidesTop: MAN_UV_RING_SCALE ** 4, // 0.4096
    topEdge: MAN_UV_RING_SCALE ** 5, // 0.32768
    topFace: MAN_UV_RING_SCALE ** 6, // 0.262144
} as const

// Tangent point between a flat face and a vertical corner, as a fraction of the ring level.
export const MAN_UV_SIDE_TANGENT = 0.6

export const topMirrorControlPoints3cm: MattressUVControlPoint[] = [
    {
        corner: true,
        sectionBreak: false,
        uv: [0.25944148454194915, -0.238842309442706],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.2583987277556169, -0.24737239235085962],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.2555498632354199, -0.25361684643240295],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.2516582419288906, -0.2559024752590132],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.25165823947430155, -0.2559024752590132],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.25554986064215895, -0.25361684643240295],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.2583987262827224, -0.24737239235085962],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.2594414834791373, -0.238842309442706],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.2594414834791373, 0.238842309442706],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.2583987262827224, 0.24737239235085962],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.25554986064215895, 0.25361684643240295],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.2516582378051806, 0.2559024752590132],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.2516582419288906, 0.2559024752590132],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.2555498632354199, 0.25361684643240295],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.25839872775561684, 0.24737239235085956],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.25944148454194915, 0.23884230944270596],
        uvSpace: "global",
    },
]

export const bottomMirrorControlPoints3cm: MattressUVControlPoint[] = [
    {
        corner: true,
        sectionBreak: false,
        uv: [0.80618426685041, -0.7417851476730413],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8067090134236262, -0.7609253323008967],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8081426354013744, -0.7801423424801112],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8101009949324656, -0.7942869958522233],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8101010108187934, -0.7942870746483741],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8081426482076999, -0.7801424059994571],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8067090239752334, -0.7609253846368453],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8061842765767333, -0.7417851959155826],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8061843005672653, 0.7417851938703792],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8067090410309716, 0.7609253913885095],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.808142658638605, 0.7801424244632346],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.8101010167099449, 0.7942871046012594],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8101010008236406, 0.794287025805029],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8081426458322986, 0.7801423609438243],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8067090304793799, 0.7609253390525077],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.8061842908409564, 0.7417851456277891],
        uvSpace: "global",
    },
]

export const bottomEdgeControlPoints: MattressUVControlPoint[] = [
    {
        corner: true,
        sectionBreak: false,
        uv: [0.6141234239767099, -0.36847404298031283],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.6141234618417928, -0.46673381883975956],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.61412326718988, -0.5649933929014462],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.5649933929014462, -0.61412326718988],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.4667338188397595, -0.6141234618417928],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.3684740429803127, -0.6141234239767098],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.36847404298031283, -0.6141234239767099],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.4667338188397595, -0.6141234618417927],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.5649933929014462, -0.61412326718988],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.6141232684786496, -0.5649933929014462],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.6141234618417928, -0.4667338188397595],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.6141234239767098, -0.3684740429803127],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.6141234239767099, 0.36847404298031283],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.6141234618417927, 0.4667338188397595],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.61412326718988, 0.5649933929014462],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.5649933929014462, 0.6141232684786497],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.4667338188397595, 0.6141234618417928],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [-0.3684740429803127, 0.6141234239767098],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.36847404298031283, 0.6141234239767099],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.46673381883975956, 0.6141234618417928],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.5649933929014462, 0.61412326718988],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.6141232671898801, 0.5649933929014462],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.6141234618417928, 0.4667338188397595],
        uvSpace: "global",
    },
    {
        corner: true,
        sectionBreak: false,
        uv: [0.6141234239767098, 0.3684740429803127],
        uvSpace: "global",
    },
]

export const footEndPanelControlPoints: MattressUVControlPoint[] = [
    {
        uv: [0.4, 0.39],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
    {
        uv: [0.4, 0.39],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
    {
        uv: [0.4, 0.42],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
    {
        uv: [0.49, 0.51],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.642, 0.64],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.81, 0.77],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.81, -0.77],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.642, -0.64],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.49, -0.51],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.4, -0.42],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.4, -0.39],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
    {
        uv: [0.385, -0.32],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
    {
        uv: [0.385, -0.26],
        uvSpace: "global",
        corner: true,
        sectionBreak: false,
    },
    {
        uv: [0.385, 0.26],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
    {
        uv: [0.385, 0.32],
        uvSpace: "global",
        corner: false,
        sectionBreak: false,
    },
]

export const headEndPanelControlPoints: MattressUVControlPoint[] = [...footEndPanelControlPoints].reverse().map((point) => ({
    ...point,
    uv: [-point.uv[0], point.uv[1]],
}))
